const officeMimeTypes: string[] = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  'application/vnd.ms-word.document.macroEnabled.12',
  'application/vnd.ms-word.template.macroEnabled.12',
];

const excelMimeTypes: string[] = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.template.macroEnabled.12',
  'application/vnd.ms-excel.addin.macroEnabled.12',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
];

const powerpointMimeTypes: string[] = [
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.template',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.ms-powerpoint.addin.macroEnabled.12',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  'application/vnd.ms-powerpoint.template.macroEnabled.12',
];

export enum FileType {
  image = 'image',
  video = 'video',
  exel = 'exel',
  word = 'word',
  powerpoint = 'powerpoint',
  pdf = 'pdf',
}

export const checkIsImage = (fileType?: string): boolean => {
  return fileType?.split('/')[0] === 'image';
};

export const checkIsVideo = (fileType?: string): boolean => {
  return fileType?.split('/')[0] === 'video';
};

export const checkIsExcelFile = (fileType?: string): boolean => {
  return excelMimeTypes.includes(fileType);
};

export const checkIsWordFile = (fileType?: string): boolean => {
  return officeMimeTypes.includes(fileType);
};

export const checkIsPowerpointFile = (fileType?: string): boolean => {
  return powerpointMimeTypes.includes(fileType);
};

export const checkIsPdfFile = (fileType?: string): boolean => {
  return fileType?.split('/')[1] === 'pdf';
};

export function getFileType(mimeType?: string): string | undefined {
  if (checkIsImage(mimeType)) return FileType.image;
  if (checkIsVideo(mimeType)) return FileType.video;
  if (checkIsWordFile(mimeType)) return FileType.word;
  if (checkIsExcelFile(mimeType)) return FileType.exel;
  if (checkIsPowerpointFile(mimeType)) return FileType.powerpoint;
  if (checkIsPdfFile(mimeType)) return FileType.pdf;
}
